import { PusatResolusiV2RequestInterface } from "../contracts/PusatResolusiV2Request";
import { TemplateChat } from "@/domain/entities/PusatResolusiV2";
import { toFormDataUtilsV2 } from "@/app/infrastructures/misc/common-library/ToFormDataUtils";
import {
  QueryParamsEntities,
  QueryParamsEntitiesV3
} from "@/domain/entities/MainApp";
import { ConvertObjectCamelToSnakeCaseV2 } from "@/app/infrastructures/misc/common-library/ConvertObjectCamelToSnakeCase";
import { getHubData } from '@/app/infrastructures/misc/Cookies';

export class CheckTicketPusatResolusiRequest {
  refNo = "";
  type = "";
  categoryCode = "";
  desc = "";
  attachments: File[] = [];
  hubId = "0";
  isEn = false

  constructor(fields?: Partial<CheckTicketPusatResolusiRequest>) {
    Object.assign(this, fields);
    this.hubId = getHubData()?.hubId || "0";
  }

  toQueryString(): string {
    return new QueryParamsEntitiesV3(this).queryString;
  }

  public toFormData() {
    return toFormDataUtilsV2(ConvertObjectCamelToSnakeCaseV2(this));
  }
}

export class CheckCategoryPusatResolusiRequest {
  sttNo = "";
  code = "";

  constructor(fields?: Partial<CheckCategoryPusatResolusiRequest>) {
    Object.assign(this, fields);
  }

  public toJSON(): string {
    const payload = {
      // eslint-disable-next-line @typescript-eslint/camelcase
      stt_no: this.sttNo,
      code: this.code
    };

    return JSON.stringify(payload);
  }
}

export class TicketCounterPusatResolusiRequest {
  ticketType = "";
  hubId = "";

  constructor(fields?: Partial<TicketCounterPusatResolusiRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class SendChatPusatResolusiRequest {
  message = "";
  hubId = 0;
  mentions: any = [];
  attachments: File[] = [];

  constructor(fields?: Partial<SendChatPusatResolusiRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntitiesV3(this).queryString;
  }

  public toFormData() {
    const data = ConvertObjectCamelToSnakeCaseV2({
      ...this,
      mentions: JSON.stringify(ConvertObjectCamelToSnakeCaseV2(this.mentions))
    });
    return toFormDataUtilsV2(data);
  }
}
export class ReopenPusatResolusiV2Request
  implements PusatResolusiV2RequestInterface {
  message = "";
  mentions: any = [];
  attachments: File[] = [];
  hubId = 0;

  constructor(fields?: Partial<ReopenPusatResolusiV2Request>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntitiesV3(this).queryString;
  }

  public toFormData() {
    const data = ConvertObjectCamelToSnakeCaseV2({
      ...this,
      mentions: JSON.stringify(ConvertObjectCamelToSnakeCaseV2(this.mentions))
    });
    return toFormDataUtilsV2(data);
  }
}

export class FinishIssuePusatResolusiV2Request
  implements PusatResolusiV2RequestInterface {
  message = "";
  hubId = 0;
  mentions: any = [];
  attachments: File[] = [];

  constructor(fields?: Partial<FinishIssuePusatResolusiV2Request>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntitiesV3(this).queryString;
  }

  public toFormData() {
    const data = ConvertObjectCamelToSnakeCaseV2({
      ...this,
      mentions: JSON.stringify(ConvertObjectCamelToSnakeCaseV2(this.mentions))
    });
    return toFormDataUtilsV2(data);
  }
}
export class SubmitNotePusatResolusiRequest {
  id = 0;
  note = "";

  constructor(fields?: Partial<SubmitNotePusatResolusiRequest>) {
    Object.assign(this, fields);
  }

  toJSON() {
    return JSON.stringify({
      note: this.note
    });
  }
}

export class ListTicketPusatResolusiRequest {
  page = 1;
  limit = 10;
  ticketType = "";
  needToBeSolved = false;
  needToReview = false;
  newMessage = false;
  mentioned = false;
  sortByDate = "";
  search = "";
  categoryIssueCode = "";
  statusTicket = "";
  ticketPriority = "";
  hubId = 0;
  startDate = "";
  endDate = "";
  isClaim = false;

  constructor(fields?: Partial<ListTicketPusatResolusiRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class GetConversationRequest {
  beforeId = 0;
  limit = 20;
  hubId = 0;

  constructor(fields?: Partial<GetConversationRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}
export class ListSTTPusatResolusi {
  page = 1;
  limit = 10;

  constructor(fields?: Partial<ListSTTPusatResolusi>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}
export class SubmitFeedbackApiRequest {
  reviewType = "";
  reviewMessage = "";

  constructor(fields?: Partial<SubmitFeedbackApiRequest>) {
    Object.assign(this, fields);
  }

  public toJSON(): string {
    const payload = {
      // eslint-disable-next-line @typescript-eslint/camelcase
      review_type: this.reviewType,
      // eslint-disable-next-line @typescript-eslint/camelcase
      review_message: this.reviewMessage
    };

    return JSON.stringify(payload);
  }
}

export class FollowTicketApiRequest {
  id = 0;
  hubId = 0;

  constructor(id: number) {
    this.id = id;
    this.hubId = getHubData()?.hubId || 0
  }

  toJSON() {
    return JSON.stringify({
      // eslint-disable-next-line @typescript-eslint/camelcase
      hub_id: this.hubId
    })
  }
}

export class AddTemplatePusatResolusiRequest {
  data: TemplateChat[] = [];

  constructor(fields?: Partial<AddTemplatePusatResolusiRequest>) {
    Object.assign(this, fields);
  }

  toJSON() {
    return ConvertObjectCamelToSnakeCaseV2(this);
  }
}

export class GetTicketActionRequest {
  hubId = 0;

  constructor(fields?: Partial<GetTicketActionRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class DownloadLaporanRequest {
  startDate = "";
  endDate = "";

  constructor(fields?: Partial<DownloadLaporanRequest>) {
    Object.assign(this, fields);
  }
  toJSON() {
    return JSON.stringify(ConvertObjectCamelToSnakeCaseV2(this));
  }
}